import Honeybadger from '@honeybadger-io/js';
import ConversationsClient from '@xo-union/sdk-conversations';
import {useQuery} from '@tanstack/react-query';

const conversationsClient = new ConversationsClient();

const useConversations = ({memberId}) =>
  useQuery(
    ['conversations'],
    async () => {
      const response = await conversationsClient.getInboxUnreadMessagesCount({
        memberId,
      });

      return response?.body?.count || 0;
    },
    {
      onError: err => {
        Honeybadger.notify(err, 'FetchConversationsError');
      },
      enabled: !!memberId,
    },
  );

export default useConversations;
